import {useEffect, useState} from 'react'

import {Formik, Form, Field} from 'formik'
import BootstrapModal from '../../components/BootstrapModal';
import * as Yup from "yup";
import TextField from "../../components/TextField";
import PMSCheckBox from "../../components/PMSCheckBox";
import {ProgressSpinner} from "primereact/progressspinner";

const MatrixOpinionForm = ({
                                   modal,
                                   roleMatrixOpinionID,
                                   title,
                                   description,
                                   weight,
                                   active,
                                   isLoading,
                                   onSubmit,
                                   onHide
                               }) => {

    const validation = Yup.object({
        title: Yup.string().required(),
        weight: Yup.number().positive(),        
    })

    return (

        <BootstrapModal headerText="Add Matrix Opinion" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    roleMatrixOpinionID: roleMatrixOpinionID,
                    title: title,
                    description:description,
                    weight:weight,                    
                    active: active,
                }}
                onSubmit={onSubmit}>
                {formik =>
                    (<Form>
                            <Field type="hidden" name="assestmentOpinionID"/>
                            <TextField label={'Title'} type="text" name="title"/>
                            <TextField label={'Description'} type="text" name="description"/>
                            <TextField label={'Weight'} type="text" name="weight"/>
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={{height: 30, width: 30}}/> :
                                <button type="submit" disabled={isLoading}
                                        className="btn btn-primary">{roleMatrixOpinionID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    )}
            </Formik>


        </BootstrapModal>
    )
}


export default MatrixOpinionForm